const SvgIcon = ({ size = '16', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 16 16"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M1.012 4.506 8 11.494l6.988-6.988"
    ></path>
  </svg>
);

export default SvgIcon;
